document.addEventListener("DOMContentLoaded", (e) => {

	const search_form = document.getElementById("frontpage-form");
	const tomselects = {};
	if (search_form) {
		const selectors = search_form.querySelectorAll("select");

		selectors.forEach((selector) => {
			let select_id = selector.getAttribute("id");

			tomselects[select_id] = new TomSelect("#" + select_id, {
				closeAfterSelect: "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0,
				maxItems: 1,
				controlInput: null,
				plugins: ["change_listener"],
				persist: false,
				create: true,
				sortField: {
					field: "text",
					direction: "asc",
				},
				onInitialize: function () {
					let placeholderValue = selector.parentNode.dataset.placeholder;

					if (placeholderValue && this.getValue().length == 0) {
						let placeholder = document.createElement("span");
						placeholder.className = "ts-placeholder";
						placeholder.innerText = selector.parentNode.dataset.placeholder;
						this.control.prepend(placeholder);
					}
				},
				render: {
					option: function (data, escape) {
						return "<div>" + '<span class="title">' + escape(data.title) + "</span>" + '<span class="count">' + escape(data.count) + "</span>" + "</div>";
					},
					item: function (data, escape) {
						return '<div class="text-brown">' + escape(data.title) + "</div>";
					},
				},
				onChange: function (value) {
					if (this.control.querySelector("span.ts-placeholder")) {
						if (value.length > 0) this.control.querySelector("span.ts-placeholder").classList.add("d-none");
						else this.control.querySelector("span.ts-placeholder").classList.remove("d-none");
					}

					this.close();
				},
			});
		});

		search_form.addEventListener("submit", (event) => {
			event.preventDefault();

			let url = themeVars.jobs_page;
			selectors.forEach((selector) => {
				let slug = selector.querySelector('option[value="' + selector.value + '"]').dataset.slug || wording.slug;
				url += slug + "/";
			});

			window.location.href = url;
		});
	}

	const map = document.querySelector('.jobs-map');
	// localize on map 
	if(map) {
		let selectZone = tomselects['select-zone'];
		let groups = map.querySelectorAll('g');
		groups.forEach((group) => {
			group.addEventListener('click', () => {
				let select_slug = group.dataset.search;
				let value = document.getElementById('select-zone').querySelector('[data-slug="'+ select_slug +'"]').value;
				group.classList.add('active');
				selectZone.addItem(value);

				search_form.requestSubmit();
				
			})
		});
	}
});
